import { classNames, React } from '@digsup/core-ui';
import { Link } from '@digsup/components-link';
import PropTypes from 'prop-types';

const cx = classNames;

export const PopoverAction = ({ href, children, className }) => {
  const classes = cx('u-font-size-7xs', className);
  return (
    <div className="c-popover__action-wrapper">
      <Link className={classes} href={href}>
        {children}
      </Link>
    </div>
  );
};

PopoverAction.propTypes = {
  /**
   * action href
   */
  href: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
};

PopoverAction.defaultProps = {
  href: '#',
};
